import { render } from "./AboutS16.vue?vue&type=template&id=27bf9ede&scoped=true"
import script from "./AboutS16.vue?vue&type=script&lang=js"
export * from "./AboutS16.vue?vue&type=script&lang=js"

import "./AboutS16.vue?vue&type=style&index=0&id=27bf9ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bf9ede"]])

export default __exports__